/**
 * Bridges Proteus' `proteus.locale.language` preference to i18next: whenever
 * the resolved value changes, call `i18n.changeLanguage(value)` so the UI
 * picks it up immediately. Also runs the one-time localStorage migration
 * (ariadne.lang → proteus.locale.language) on first authed load.
 */
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ProteusCoreKeys } from '@francisquiniai/proteus-sdk'
import {
  useLocalStorageMigration,
  useProteusPrefs,
} from '@francisquiniai/proteus-sdk/react'

export function useProteusLanguageSync(): void {
  const { i18n } = useTranslation()
  const { get, isLoading } = useProteusPrefs()

  useLocalStorageMigration()

  useEffect(() => {
    if (isLoading) return
    const lang = get<string>(ProteusCoreKeys.language)
    if (lang && lang !== i18n.language) {
      void i18n.changeLanguage(lang)
    }
  }, [get, i18n, isLoading])
}
